var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33268 2V2.33333C5.33268 2.88562 5.7804 3.33333 6.33268 3.33333H9.66602C10.2183 3.33333 10.666 2.88562 10.666 2.33333V2H11.9993C12.7357 2 13.3327 2.59695 13.3327 3.33333V14C13.3327 14.7364 12.7357 15.3333 11.9993 15.3333H3.99935C3.26297 15.3333 2.66602 14.7364 2.66602 14V3.33333C2.66602 2.59695 3.26297 2 3.99935 2H5.33268Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 1.33317C7.33333 0.964981 7.63181 0.666504 8 0.666504C8.36819 0.666504 8.66667 0.964981 8.66667 1.33317H9.66667C9.85076 1.33317 10 1.48241 10 1.6665V2.33317C10 2.51727 9.85076 2.6665 9.66667 2.6665H6.33333C6.14924 2.6665 6 2.51727 6 2.33317V1.6665C6 1.48241 6.14924 1.33317 6.33333 1.33317H7.33333Z",
    fill: "#323130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.666 6H7.33268C6.96449 6 6.66602 6.29848 6.66602 6.66667C6.66602 7.03486 6.96449 7.33333 7.33268 7.33333H10.666C11.0342 7.33333 11.3327 7.03486 11.3327 6.66667C11.3327 6.29848 11.0342 6 10.666 6Z",
    fill: "#323130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.99935 6.66667C5.99935 6.29848 5.70087 6 5.33268 6C4.96449 6 4.66602 6.29848 4.66602 6.66667C4.66602 7.03486 4.96449 7.33333 5.33268 7.33333C5.70087 7.33333 5.99935 7.03486 5.99935 6.66667Z",
    fill: "#323130"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.99935 9.33317C5.99935 8.96498 5.70087 8.6665 5.33268 8.6665C4.96449 8.6665 4.66602 8.96498 4.66602 9.33317C4.66602 9.70136 4.96449 9.99984 5.33268 9.99984C5.70087 9.99984 5.99935 9.70136 5.99935 9.33317Z",
    fill: "#323130"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.666 8.6665H7.33268C6.96449 8.6665 6.66602 8.96498 6.66602 9.33317C6.66602 9.70136 6.96449 9.99984 7.33268 9.99984H10.666C11.0342 9.99984 11.3327 9.70136 11.3327 9.33317C11.3327 8.96498 11.0342 8.6665 10.666 8.6665Z",
    fill: "#323130"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.99935 12.0002C5.99935 11.632 5.70087 11.3335 5.33268 11.3335C4.96449 11.3335 4.66602 11.632 4.66602 12.0002C4.66602 12.3684 4.96449 12.6668 5.33268 12.6668C5.70087 12.6668 5.99935 12.3684 5.99935 12.0002Z",
    fill: "#323130"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.666 11.3335H7.33268C6.96449 11.3335 6.66602 11.632 6.66602 12.0002C6.66602 12.3684 6.96449 12.6668 7.33268 12.6668H10.666C11.0342 12.6668 11.3327 12.3684 11.3327 12.0002C11.3327 11.632 11.0342 11.3335 10.666 11.3335Z",
    fill: "#323130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.04b71b23.svg";
export { ForwardRef as ReactComponent };